(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-home"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.tll-home').forEach((home) => {
    home.classList.add('is-js');
    const revealItems = home.querySelectorAll('[data-reveal]');
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });
      revealItems.forEach((item) => observer.observe(item));
    } else {
      revealItems.forEach((item) => item.classList.add('is-visible'));
    }

    const mobileCta = home.querySelector('.tll-mobile-cta');
    const heroCta = home.querySelector('.tll-hero .tll-button--primary');
    const closing = home.querySelector('.tll-closing');
    if (mobileCta && heroCta) {
      let ctaFrame = null;
      const updateMobileCta = () => {
        ctaFrame = null;
        const heroRect = heroCta.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedHeroCta = heroRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        mobileCta.classList.toggle('is-visible', passedHeroCta && !closingIsVisible);
      };
      const queueMobileCtaUpdate = () => {
        if (ctaFrame) return;
        ctaFrame = window.requestAnimationFrame(updateMobileCta);
      };
      window.addEventListener('scroll', queueMobileCtaUpdate, { passive: true });
      window.addEventListener('resize', queueMobileCtaUpdate);
      updateMobileCta();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-behavior-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-gifting-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product-before-recipient-style-20260830"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const purchaseModes = section.querySelectorAll('[data-purchase-mode]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    const syncPurchaseMode = () => {
      const selected = section.querySelector('[data-purchase-mode]:checked');
      purchaseModes.forEach((input) => {
        const card = input.closest('[data-purchase-mode-card]');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
      const activeLabel = selected && selected.value === 'gift'
        ? addButton.dataset.giftLabel
        : addButton.dataset.availableLabel;
      if (addLabel && addButton && !previewMode && !addButton.disabled) {
        addLabel.textContent = activeLabel;
      }
      if (stickyLabel && addButton && !previewMode && !addButton.disabled) {
        stickyLabel.textContent = activeLabel;
      }
    };

    purchaseModes.forEach((input) => input.addEventListener('change', syncPurchaseMode));
    syncPurchaseMode();

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        syncPurchaseMode();
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tll-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tll-product]').forEach((section) => {
    const variantInput = section.querySelector('[data-variant-id]');
    const price = section.querySelector('[data-product-price]');
    const buttonPrice = section.querySelector('[data-button-price]');
    const addButton = section.querySelector('[data-add-button]');
    const addLabel = section.querySelector('[data-add-label]');
    const variantStatus = section.querySelector('[data-variant-status]');
    const radios = section.querySelectorAll('[data-variant-radio]');
    const galleryMain = section.querySelector('[data-gallery-main]');
    const galleryThumbs = section.querySelectorAll('[data-gallery-thumb]');
    const galleryStatus = section.querySelector('[data-gallery-status]');
    const purchaseModes = section.querySelectorAll('[data-purchase-mode]');
    const stickyAdd = section.querySelector('[data-sticky-add]');
    const stickyLabel = section.querySelector('[data-sticky-label]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const previewMode = section.dataset.previewMode === 'true';

    const syncPurchaseMode = () => {
      const selected = section.querySelector('[data-purchase-mode]:checked');
      purchaseModes.forEach((input) => {
        const card = input.closest('[data-purchase-mode-card]');
        if (card) card.classList.toggle('is-selected', input.checked);
      });
      const activeLabel = selected && selected.value === 'gift'
        ? addButton.dataset.giftLabel
        : addButton.dataset.availableLabel;
      if (addLabel && addButton && !previewMode && !addButton.disabled) {
        addLabel.textContent = activeLabel;
      }
      if (stickyLabel && addButton && !previewMode && !addButton.disabled) {
        stickyLabel.textContent = activeLabel;
      }
    };

    purchaseModes.forEach((input) => input.addEventListener('change', syncPurchaseMode));
    syncPurchaseMode();

    radios.forEach((radio) => {
      radio.addEventListener('change', () => {
        if (!radio.checked) return;
        variantInput.value = radio.value;
        price.textContent = radio.dataset.price;
        buttonPrice.textContent = radio.dataset.price;
        const available = radio.dataset.available === 'true';
        if (addButton) addButton.disabled = previewMode || !available;
        if (addLabel && addButton) {
          if (!previewMode) addLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        }
        if (stickyAdd) stickyAdd.disabled = previewMode || !available;
        if (stickyLabel && !previewMode) stickyLabel.textContent = available ? addButton.dataset.availableLabel : addButton.dataset.unavailableLabel;
        syncPurchaseMode();
        if (stickyPrice) stickyPrice.textContent = radio.dataset.price;
        section.querySelectorAll('[data-variant-card]').forEach((card) => card.classList.remove('is-selected'));
        radio.closest('[data-variant-card]').classList.add('is-selected');
        if (variantStatus) {
          variantStatus.textContent = `${radio.dataset.variantTitle}. ${radio.dataset.price}. ${available ? 'Available' : 'Currently unavailable'}.`;
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', radio.value);
        window.history.replaceState({}, '', url);
      });
    });

    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!galleryMain) return;
        galleryMain.src = thumb.dataset.gallerySrc;
        galleryMain.srcset = thumb.dataset.gallerySrcset || '';
        galleryMain.sizes = thumb.dataset.gallerySizes || '(min-width: 900px) 52vw, 100vw';
        galleryMain.alt = thumb.dataset.galleryAlt || '';
        galleryThumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
        if (galleryStatus) galleryStatus.textContent = `${thumb.dataset.galleryTitle} selected.`;
      });
    });

    if (stickyAdd && addButton) {
      const closing = section.querySelector('.tll-product__closing');
      let stickyFrame = null;
      const updateStickyAdd = () => {
        stickyFrame = null;
        const addRect = addButton.getBoundingClientRect();
        const closingRect = closing ? closing.getBoundingClientRect() : null;
        const passedPrimaryButton = addRect.bottom < 0;
        const closingIsVisible = closingRect && closingRect.top < window.innerHeight && closingRect.bottom > 0;
        stickyAdd.classList.toggle('is-visible', passedPrimaryButton && !closingIsVisible);
      };
      const queueStickyAddUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = window.requestAnimationFrame(updateStickyAdd);
      };
      window.addEventListener('scroll', queueStickyAddUpdate, { passive: true });
      window.addEventListener('resize', queueStickyAddUpdate);
      updateStickyAdd();
    }

  });

  } catch(e) { console.error(e); }
})();
})();
